import { Component, OnInit, Input, ViewChild, Renderer2, ElementRef, OnChanges, SimpleChanges } from '@angular/core';
import * as L from 'leaflet';

@Component({
  selector: 'app-map-park-points',
  templateUrl: './map-park-points.component.html',
  styleUrls: ['./map-park-points.component.scss']
})

export class MapParkPointsComponent implements OnInit {

  @Input() data: any;
  @ViewChild('parkPointsMap', {static: true}) protected mapDivRef: ElementRef;

  map: any;
  layerGroup: any;
  layerGroupShapes: any;

  protected mapDiv: HTMLDivElement;

  constructor() { }

  ngOnInit(): void {
    this.mapDiv = this.mapDivRef.nativeElement;

    // console.log("init map park points", this.data);

    const myAPIKey = "0162482e691040afa6ac3cbfc6dbc92d";
    const mapStyle = "https://maps.geoapify.com/v1/styles/osm-carto/style.json";

    this.map = L.map('parkPointsMap', { scrollWheelZoom: false }).setView([19.400119, -99.194519], 12);

    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
 			maxZoom: 16,
 			minZoom: 10,
 		}).addTo(this.map);

    // INIT layerGroups
    this.layerGroup = L.layerGroup().addTo(this.map);
    this.layerGroupShapes = L.layerGroup().addTo(this.map);

    this.buildMap(this.data.filters);
  }

  private async buildMap (data) {

    let iconMarker = L.icon({
      iconUrl: 'assets/images/marker-icon.png'
    })
    data.map((el) => {
      let LatLong = Object.prototype.toString.call(el.geo_point) == "[object String]" ? el.geo_point.split(",") : el.geo_point;
      let MarkerOptions = {
		    radius: 8,
		    fillColor: "#ff7800",
		    color: "#000",
		    weight: 1,
		    opacity: 1,
		    fillOpacity: 0.8,
        border: 0,
        icon: iconMarker,
        outline: 0
			};
      if (LatLong.length > 1) {
        L.marker(LatLong, MarkerOptions)
          .bindPopup(`
            <b style="font-size: 16px;">${el.descriptio}</b>
          `)
          .addTo(this.layerGroup);
      }
    });
  }

}
